/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipBackIcon20Light = forwardRef('MediaUiASkipBackIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 3.5a.5.5 0 0 1 1 0v6.038c.092-.246.261-.468.507-.627L14.3 3.185a1.1 1.1 0 0 1 1.7.922v11.786a1.1 1.1 0 0 1-1.7.922L5.507 11.09A1.286 1.286 0 0 1 5 10.462V16.5a.5.5 0 0 1-1 0v-13Zm11 .607a.1.1 0 0 0-.155-.084L6.052 9.749a.3.3 0 0 0 0 .502l8.793 5.726a.1.1 0 0 0 .155-.084V4.107Z" })));
});
